module.exports = __webpack_public_path__ + "static/media/stocks.a9a84cba.jpg";